import { requestServices } from 'repos';
import { getResult } from 'helpers/request';
import { IDynamicSearch, ITerminalSearch } from 'interfaces';

import { merchantService } from 'packages/request/clients';
const { merchantOnboard } = requestServices;
/**
 * search terminals
 * @param {object} params
 * @returns {Promise<AxiosResponse<T>>}
 */
const searchTerminals = (params: IDynamicSearch) => {
  return merchantService
    .get('/terminals/', {
      params,
    })
    .then(getResult);
};

const getListTerminalWaiting = async (params: ITerminalSearch) => {
  return merchantOnboard
    .get('/terminals/waiting', {
      params,
    })
    .then(getResult);
};

const createTerminal = (data: any) => {
  return merchantService.post('/terminals/', data).then(getResult);
};

const updateTerminal = (id: number, data: any) => {
  return merchantService.put(`/terminals/${id}`, data).then(getResult);
};

const addServiceToTerminal = (data: any) => {
  return merchantService.post('/terminal-services/', data).then(getResult);
};

const changeApproveStatus = (tsId: number, data: any) => {
  return merchantService
    .put(`/terminal-services/change-approval-status/${tsId}`, data)
    .then(getResult);
};

const getTerminalById = async (terminalId: number) => {
  return merchantService.get(`/terminals/${terminalId}`).then(getResult);
};

export default {
  updateTerminal,
  searchTerminals,
  createTerminal,
  addServiceToTerminal,
  getTerminalById,
  getListTerminalWaiting,
  changeApproveStatus,
};
